import { TagFilled } from '@ant-design/icons';
import { Space } from 'farmhub-ui-core';

import { SIZE } from 'utils';

import { Dot, Wrapper } from './styles';

const TagOption = ({
  hideDot = false,
  color,
  padding,
  fontSize,
  label,
  styles,
  size = SIZE.DEFAULT,
  notShowPointer,
  onClick,
}: OrderStatusProps): JSX.Element => (
  <Wrapper
    background={color}
    fontSize={fontSize}
    notShowPointer={notShowPointer}
    padding={padding}
    styles={styles}
    onClick={e => {
      e.stopPropagation();
      onClick && onClick();
    }}
  >
    {!hideDot && <Dot color={color} fontSize={fontSize} />}

    {size === SIZE.LARGE && (
      <>
        {!hideDot && <Space width={8} />}
        {label}
      </>
    )}

    {size === SIZE.DEFAULT && (
      <>
        {!hideDot && <Space width={4} />}
        <span>{label}</span>
      </>
    )}
  </Wrapper>
);

export default TagOption;

interface OrderStatusProps {
  hideDot?: boolean;
  color: string;
  padding?: string;
  fontSize?: number;
  label?: string;
  styles?: any;
  size?: SIZE;
  onClick?: () => void;
  notShowPointer?: boolean;
}
